import { EventActions, UpdateEventRequest } from "../domain/events";
import { updateEventService } from "../infrastructure/services/updateEventService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const updateEvent = {
  async execute(name: string, lastname: string, maxInvites: number): Promise<void> {
    const request: UpdateEventRequest =
      await EventActions().updateEventRequest(
        name,
        lastname,
        maxInvites
      );
    await updateEventService.execute(await tokenValidation.execute(), request);
  },
};
